export class RegistrationModel {
    email: string;
    password: string;
    passwordConfirmation: string;
    agree: boolean;
    ref: string;

}



// WEBPACK FOOTER //
// ./src/app/public/registration/registration.models.ts